module.exports = __webpack_public_path__ + "static/media/bancontact-logo.37a6fd13.png";